export default {
	modifier: 'Modifier mot de passe',
	actuel: 'Mot de passe actuel',
	titre: 'Mot de passe',
	description: 'La modification du mot de passe correspond à celui de votre compte Questionnaire Risque Professionnel (connexion avec identifiants QRP). Il ne s\'agit pas de celui de FranceConnect.'
};
